import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'relative',
    width: '100%',

    '@lg': {
        paddingLeft: `calc(4 * $colWidth)`,
        paddingRight: `calc(4 * $colWidth)`,
    },
})

export const TitleFooter = styled('div', {
    position: 'absolute',
    top: '50%',
    left: '$xs',
    transform: 'translateY(-50%)',

    '@lg': {
        left: 'calc(3 * $colWidth)',
    },
})
